import { render } from "./MicPermissionRequest.vue?vue&type=template&id=1f29bc62&scoped=true"
import script from "./MicPermissionRequest.vue?vue&type=script&lang=js"
export * from "./MicPermissionRequest.vue?vue&type=script&lang=js"

import "./MicPermissionRequest.vue?vue&type=style&index=0&id=1f29bc62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f29bc62"]])

export default __exports__